module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAASxJREFUOE/tVe0NgjAQpRPoCGygTiBOgCPABOIE4ATqBLKBOoG4ASMwAk6A7zVtUmtBCPz0kkt718fzeh9VNE0TeZ53hM6hLomFEDkPgE0U1oWr4dwLgLi5QeVHlmxh70AoFGGD9azwNpaBhSQkaINvChuBowC+h0XYjf0TfqRxTA5PLZVjUTKrKBl8XwWEjx0Rs8os98XRMtp1ACFJ2Idc0w5sLPtrSpme8Mc4MXjzypyqWceNSj0pbePEoqRGUXLYfh/CXqPXJ9dDZ5mtUSHiEqni6xRC77Br2IzcH0rIh+QJgsDIvbwd7AJnizGEuidNwvUYwggRcSBWKgWMUBKyFa5QVtAW5iyxRk9emUDmDftK7flIL/XocZZd/fVShPLHQFBiKUDCvwKnvAGmSBv6br56bgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/pC/code-white.png
// module id = GryR
// module chunks = 1